/**
 * Handles of the illustrative sample instructors shown on /instructors.
 * Kept separate from sampleInstructors.ts so the router can tell a sample
 * handle from a real profile slug without importing the sample data.
 *
 * SampleInstructor["handle"] is typed against SampleHandle, so adding a sample
 * without listing it here is a type error rather than a silent 404.
 */
export const SAMPLE_HANDLE_LIST = [
  "sarahdrives",
  "coledogs",
  "diegostrings",
  "kenjidojo",
  "aishasafety",
  "fletchermaths",
  "lenadrives",
] as const;

export type SampleHandle = (typeof SAMPLE_HANDLE_LIST)[number];

export const SAMPLE_HANDLES: ReadonlySet<string> = new Set(SAMPLE_HANDLE_LIST);
